var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { logger } from '~/classes/Logger';
import { StatusFetch } from '~/enum';
import { convertDataLogoClbTexture } from '~/utils/common';
const useFetchLogoClbSpriteSheet = (json, imgSrc) => {
    const [data, setData] = useState(null);
    const [status, setStatus] = useState(StatusFetch.IDLE);
    const loadSpriteSheet = (json, imageSrc, controller) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // Load JSON data
            setStatus(StatusFetch.LOADING);
            const response = json;
            // Load image using a Promise
            const spriteImage = yield loadImage(imageSrc);
            if (controller.signal.aborted) {
                console.warn('Sprite sheet loading was aborted');
                return;
            }
            setData({
                textureData: convertDataLogoClbTexture(response.frames),
                spriteImage,
            });
            setStatus(StatusFetch.SUCCESS);
        }
        catch (error) {
            logger.error('Error loading sprite sheet:', error);
            setStatus(StatusFetch.ERROR);
        }
    });
    const loadImage = (src) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                resolve(img);
            };
            img.onerror = () => {
                reject(new Error(`Failed to load image: ${src}`));
            };
            img.src = src;
        });
    };
    useEffect(() => {
        if (!json || !imgSrc) {
            console.warn('JSON source or image source is not provided');
            return;
        }
        const controller = new AbortController();
        loadSpriteSheet(json, imgSrc, controller);
        return () => controller.abort();
    }, [json, imgSrc]);
    return {
        data,
        status,
    };
};
export default useFetchLogoClbSpriteSheet;
